module.exports = __webpack_public_path__ + "static/email-6a199000f19d125b741e460c4b76c048.svg";